/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhStripe.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";

class ZhStripe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="ZhStripe-view">
        <Helmet>
          <title>Stripe - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="ZhStripe-section">
          <div className="ZhStripe-partnerwithstripe" />
        </div>

        <div className="ZhStripe-section2">
          <div className="ZhStripe-heading ZhStripe-firstTxt">
            我們跟 Stripe 合作，安全地處理了所有信用卡付款。
          </div>
          <div className="ZhStripe-cardContainer">
            <div className="ZhStripe-visaIcon" />
            <div className="ZhStripe-mastercardIcon" />
            <div className="ZhStripe-amexIcon" />
            <div className="ZhStripe-unionpayIcon" />
            <div className="ZhStripe-applePay" />
            <div className="ZhStripe-googlePay" />
          </div>
        </div>

        <div className="ZhStripe-section3">
          <div className="ZhStripe-featuresContainer">
            <div className="ZhStripe-aes">AES-256</div>
            <div className="ZhStripe-txt">
              所有卡號碼均使用 AES-256
              技術加密，全球各大銀行和政府也使用相同的加密技術。
            </div>
          </div>
          <div className="ZhStripe-featuresContainer">
            <div className="ZhStripe-pci" />
            <div className="ZhStripe-txt">
              Stripe是經過 PCI 認證的信用卡支付處理公司，以確保數據安全。
            </div>
          </div>
        </div>

        <div className="ZhStripe-section4">
          <div className="ZhStripe-heading ZhStripe-text4">
            需要註冊一個 Stripe 帳戶？
          </div>

          <div className="ZhStripe-notepadContainer">
            <div className="ZhStripe-notepad" />
          </div>
          <div className="ZhStripe-txt ZhStripe-description4">
            不需要，當您註冊 CheckPlus 的時候，我們的系統會自動在我們端設置一個
            Stripe 帳戶。因此，您只需要透過一個平台處理所有付款。
          </div>
        </div>

        <div className="ZhStripe-section5">
          <div className="ZhStripe-logo" />
          <div className="ZhStripe-txt ZhStripe-description5">
            立即登記跟 Stripe 合作的 CheckPlus
          </div>
          <Link to="/OrgLogin">
            <div className="ZhStripe-first-bar">立即登記</div>
          </Link>
        </div>

        <div className="ZhStripe-footer">
          <div className="ZhStripe-footerNav">
            <Link to="/ZhTeam">
              <div className="ZhStripe-footerNavItem">創辦人的故事</div>
            </Link>
            <Link to="/ZhFaq">
              <div className="ZhStripe-footerNavItem">常見問題</div>
            </Link>
            <Link to="/ZhContact">
              <div className="ZhStripe-footerNavItem">聯絡我們</div>
            </Link>

            <Link to="/ZhPrivacyPolicy">
              <div className="ZhStripe-footerNavItem">私隱政策</div>
            </Link>

            <Link to="/ZhTerms">
              <div className="ZhStripe-footerNavItem">使用條款</div>
            </Link>
          </div>

          <div className="ZhStripe-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default ZhStripe;
